import React from "react";
import { Row, Col } from "antd";
import AccountRemain from "./card/accountRemain";
import PeakLoadPanel from "./panel/peakLoadPanel";
import IncomeSmartbilling from "./panel/incomeSB";
import SbIncomeDetail from "./panel/incomeSbDetail";
import RedisCacheAdmin from "./panel/redisCacheAdmin";

const AdminDashboard = () => {
  return (
    <div style={{ padding: 24 }}>
      <Row gutter={16}>
        <Col span={24}>
          <AccountRemain />
        </Col>
        <Col span={24}>
          <PeakLoadPanel />
        </Col>
        <Col span={24}>
          <IncomeSmartbilling />
        </Col>
        <Col span={24}>
          <SbIncomeDetail />
        </Col>
        <Col span={24}>
          <RedisCacheAdmin />
        </Col>
      </Row>
    </div>
  );
};

export default AdminDashboard;
